module.exports = __webpack_public_path__ + "static/img/coupon_caidai.142de53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/coupon_caidai.png
// module id = 4lGY
// module chunks = 4